import capitalize from "lodash/capitalize";

export function statusToString(status: string) {
  status = status.replace("_", " ");

  return capitalize(status);
}
